module["exports"] = [
  "ایران"
];
